import { FunctionComponent, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { CorpoTable, Tabela, TabelaCabeca, TabelaCorpo } from '../../../../components/formulario/tableStyled';
import { CircularProgress } from "@mui/material";
import { Tabler } from "../../../../components/formulario/tableStyled";
import ChipBatizado from "../../../Batismo/Membros/components/chips/batizado";
import { useServicesMembrosCheckin } from "../context/getMembros";



interface TableConexaoProps {

}

const TableConexao: FunctionComponent<TableConexaoProps> = () => {

  const [loading, setLoading] = useState();

  const devRef = useRef<any>(null);

  const { listAll, nome, pagina, nextPagina } = useServicesMembrosCheckin();

  useMemo(() => {
    listAll?.slice(0, ((pagina + 1) * 30))
  }, [pagina]);

  useEffect(() => {
    if (devRef.current) {
      devRef.current.addEventListener('scroll', (e: any) => {
        if (e.target?.scrollTop >= (e.target.scrollHeight - (e.target.clientHeight + 60))) {
          nextPagina()
        }
      })
    }
  }, [devRef]);


  const Td = useCallback(() => <>
    {
      listAll
        .filter(elem => String(elem?.nome)
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .toLocaleLowerCase()
          .match(
            (nome || '')
              .normalize('NFD')
              .replace(/[\u0300-\u036f]/g, '')
              .toLocaleLowerCase()
          )
        )
        .splice(0, (pagina + 1) * 30).map((elem, key) => <tr>
          <td>{elem?.['nome']}</td>
          <td>{elem?.['telefone']}</td>
          <td>{elem?.['email']}</td>
          <td>{elem?.['nomeevento']}</td>
          <td>{elem?.['igreja_origem'] || '-'}</td>
          <td><ChipBatizado status={elem?.['batizado']} /></td>
          {/* <td>{elem?.['ministerio_desejado']}</td> */}
          <td>{elem?.['inscricao']}</td>
        </tr>)
    }
  </>, [pagina, listAll])

  return (<>
        <Tabler>
          <CorpoTable
            ref={
              devRef
            }>
            {
              loading ?
                <div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  < CircularProgress />
                </div>
                :
                <Tabela>
                  <>
                    <TabelaCabeca>
                      <tr>
                        <th>Nome</th>
                        <th>Telefone</th>
                        <th>E-mail</th>
                        <th>Evento</th>
                        <th>Igreja Origem</th>
                        <th>Batizado</th>
                        {/* <th>Ministério</th> */}
                        <th>Inscrição</th>
                      </tr>
                    </TabelaCabeca>
                    <TabelaCorpo >
                      <Td />
                    </TabelaCorpo>
                  </>
                </Tabela>
            }
          </CorpoTable>
        </Tabler>
  </>);
}

export default TableConexao;
